import {
    TextField,
    TextFieldProps,
    TextFieldVariants
} from '@mui/material';
import { FC } from 'react';
import './AppTextField.css';

export const AppTextField: FC<{
    variant?: TextFieldVariants;
    required?: boolean;
} & Omit<TextFieldProps, "variant">> = ({ required, ...props }) => (
    <div className="app-text-field" >
        <TextField { ...props } />
        {
            required
            ? (
                <div className='app-text-field-required' >
                    <div className='app-text-field-required-content' >*</div>
                </div>
            )
            : null
        }
    </div>
);
